import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Box, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {LocaleContext} from '../../../ts/routing/LangRouter';
import {getAppointmentPageUrl} from '../../../ts/routing/routingConstants/AppUrls';
import {useTranslation} from 'react-i18next';
import {useStyles} from './styles';

const CarWindow = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const {locale} = useContext(LocaleContext);
    const {t} = useTranslation();
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_KEY}/arscustom/public/services/tint-glass-services`, {
                        params: {"special": true},
                    }
                );
                // Filter for isSpecial services and ensure enabled is true
                const specialServices = response.data
                    .filter(service => service.isSpecial)
                    .map(service => ({
                        id: service.id,
                        model: locale === 'fr' ? service.modelFr : service.modelEn,
                        price: service.price,
                        discountPrice: service.discountPrice,
                        currency: service.currency,
                        imageUrl: service.imageUrl,
                        isSpecial: service.isSpecial,
                    }));
                setServices(specialServices);
                setError(null);
            } catch (error) {
                console.error('Error fetching tint glass services:', error);
                setError(t('common.error'));
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
    }, [locale, t]);

    const memoizedServices = useMemo(
        () =>
            services.map(service => (
                <Box className={classes.wrapper} key={service.id}>
                    {/*{service.discountPrice > 0 && (*/}
                    {/*    <Box className={classes.box}>*/}
                    {/*        <span>{`${service.discountPrice}%`}</span>*/}
                    {/*    </Box>*/}
                    {/*)}*/}
                    <img
                        className={classes.car}
                        src={service.imageUrl}
                        alt={`Car Window ${service.model}`}
                    />
                    <Box className={classes.title}>
                        {service.model}
                    </Box>

                    {service.discountPrice !== service.price ? (
                        <Box>
                            {/* Original price, crossed out */}
                            <Box className={classes.discountedPrice}>
                                {`${service.price} ${service.currency}`}
                            </Box>

                            {/* Actual discounted price */}
                            <Box className={classes.newPrice}>
                                {`${service.discountPrice} ${service.currency}`}
                            </Box>
                        </Box>
                    ) : (
                        // No discount, just show normal price
                        <Box className={classes.newPrice}>
                            {`${service.price} ${service.currency}`}
                        </Box>
                    )}


                    <button
                        className={classes.button}
                        onClick={() =>
                            navigate(getAppointmentPageUrl(locale), {
                                state: {
                                    tintedGlass: {
                                        id: service.id,
                                        modelEn: service.modelEn,
                                        modelFr: service.modelFr,
                                        price: service.price,
                                        discountPrice: service.discountPrice,
                                        currency: service.currency,
                                        isSpecial: service.isSpecial,
                                    },
                                    model: service.model,
                                    amount: service.discountPrice
                                },
                            })
                        }
                    >
                        {t('common.book_appointment')}
                    </button>
                </Box>
            )),
        [services, classes, locale, navigate, t]
    );

    if (loading) {
        return <Typography sx={{textAlign: 'center', my: 2}}>{t('common.loading')}</Typography>;
    }

    if (error) {
        return <Typography color="error" sx={{textAlign: 'center', my: 2}}>{error}</Typography>;
    }

    if (services.length === 0) {
        return <Typography sx={{textAlign: 'center', my: 2}}>{t('common.no_services')}</Typography>;
    }

    return <Box className={classes.container}>{memoizedServices}</Box>;
};

export default CarWindow;

CarWindow.propTypes = {};